import React from "react";
import { noHandler } from "@/components/ReactRangePicker/utils";

import "./index.scss";

const Navigator = ({
  month = "",
  year = 2018,
  onMonthChange = noHandler("no month change handler"),
  onSelectMonth = noHandler(" no month select handler"),
  onSelectYear = noHandler(" no year select handler"),
}) => {
  return (
    <div className="navigator">
      <button
        className="arrow prev btn btn-outline ripple"
        onClick={(event) => {
          onMonthChange(-1);

          event.preventDefault(); // 阻止表单提交的默认行为
          event.stopPropagation(); // 阻止事件冒泡
        }}
      />
      <div className="values">
        <button
          className="month btn btn-outline ripple"
          onClick={(event) => {
            onSelectMonth(); // 调用选择月份的处理函数
            event.preventDefault(); // 阻止表单提交的默认行为
            event.stopPropagation(); // 阻止事件冒泡
          }}
        >
          {" "}
          {month}{" "}
        </button>
        <button
          className="year btn btn-outline ripple"
          onClick={(event) => {
            onSelectYear(); // 调用选择年份的处理函数
            event.preventDefault(); // 阻止表单提交的默认行为
            event.stopPropagation(); // 阻止事件冒泡
          }}
        >
          {" "}
          {year}{" "}
        </button>
      </div>
      <button
        className="arrow next btn btn-outline ripple"
        onClick={(event) => {
          onMonthChange(1);
          event.preventDefault(); // 阻止表单提交的默认行为
          event.stopPropagation(); // 阻止事件冒泡
        }}
      />
    </div>
  );
};

export default Navigator;
